import React from 'react';
import styles from './style.module.scss';
/**
 * A Simply SocialIcon component
 *
 * @param	{string}	url    	      social network url
 * @param	{string}	src	          url from image
 * @param	{string}	height		    Logo height
 * @param	{string}	width 		    Logo width
 * @param	{string}	title 		    Name or Description of social network
 * @param	{string}	backgroundColor  Transparent or color
 *
 **/

var SocialIcon = function SocialIcon(_ref) {
  var _ref$url = _ref.url,
      url = _ref$url === void 0 ? '' : _ref$url,
      _ref$src = _ref.src,
      src = _ref$src === void 0 ? '' : _ref$src,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '50' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '50' : _ref$height,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
  return React.createElement("div", {
    style: {
      backgroundColor: backgroundColor
    },
    className: styles.socialContainer
  }, React.createElement("a", {
    href: url,
    target: "_blank",
    rel: "nofollow noopener noreferrer",
    "aria-label": "sharethis",
    title: title
  }, React.createElement("img", {
    src: src,
    width: width,
    height: height,
    alt: title
  })));
};

export default React.memo(SocialIcon);